export const APPLICATION_NAME = 'Messenger';

export const QUICK_OPTIONS_COUNT_LIMIT = 16;

export const QUICK_SUM_OPTIONS_LENGTH_LIMIT = 150;

export const QUICK_OPTION_LENGTH_LIMIT = 15;

export const GOODBYE_MESSAGE_HEADER = 'Survey Completed';

export const GOODBYE_MESSAGE_CONTENT = 'You have reached the end of the survey.';

export const INVALID_ERROR_MESSAGE = 'No response from server';

export const SURVEY_TESTING_PATH = 'survey-testing';

export const TIMEOUT_DELAY = 150;

export const SMALL_TIMEOUT_DELAY = 100;

export const MILLISECONDS_TO_SECONDS = 1000;

/** Last-resort safety valve for an armed submission that the socket never resolves. Reconnects release
 * the guard on their own, so this only covers a still-open socket that silently never answers. Kept
 * generous on purpose: releasing early re-opens the duplicate-submit window this guard exists to close. */
export const SUBMISSION_IN_FLIGHT_TIMEOUT_MS = 30 * MILLISECONDS_TO_SECONDS;

export const END_OF_VIDEO_TOLERANCE = 0.75; // seconds - tolerance for considering video "ended"

/** Max width/height (px) for scale legend anchor images */
export const SLIDER_QUESTION_LEGEND_ICON_MAX_PX = 32;
